
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scuola-dell-infanzia",
      function () {
        return require("private-next-pages/scuola-dell-infanzia/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scuola-dell-infanzia"])
      });
    }
  